import React, { useEffect } from 'react'
import styles from "./aboutus.module.css"
import { Border } from '../../components/maincomps/border/Border'
import Testimonial from '../../components/testimonial/Testimonial'
import Counter from '../home/counter/Counter'
import { useLocation } from 'react-router-dom'
import CustomSeparator from '../../components/maincomps/breadcrumbs/Breadcrumbs'
import breadcrumbStyle from '../../components/maincomps/breadcrumbs/breadcrumbs.module.css'
import { getAppearances } from '../../../redux/homeSlice'
import { CircularProgress } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'


const Aboutus = () => {

    const dispatch = useDispatch();
    const { appearanceData, isLoading } = useSelector((state) => state.appearances);

    const aboutUsData = appearanceData?.aboutus


    useEffect(() => {
        dispatch(getAppearances())
    }, [dispatch])

    if (isLoading) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 20 }}>
                <CircularProgress />
            </div>
        )
    }


    return (
        <>
            <div className={breadcrumbStyle.breadcrumbStyle}>
                <CustomSeparator home="Home" type="About us" />
            </div>
            <div>
                <div className={styles.image_section}>
                    <img src="/pavithrajewelslogo.png" alt="login" />
                    <div className={styles.imagetitle}>
                        <p> House of Exquisite Premium Jewellery</p>
                    </div>
                </div>
                

                {/*  Image title */}
                <div className={styles.imgtitleCont}>
                    <div className={styles.imgtitle1}>
                        <img src="/img/img2729.jpg" alt="JewelryImage1" />
                    </div>
                    <div className={styles.imgtitle2}>
                        <img src="/img/img2763.jpg" alt="JewelryImage" />
                    </div>
                    <div className={styles.imgtitle3}>
                        <img src="/img/img2764.jpg" alt="JewelryImage" />
                    </div>
                </div>


                {/*  About us */}
                <div className={styles.aboutservice}>
                    <div className={styles.aboutmainLeft}>
                        <h6>About us</h6>
                        <h2>{aboutUsData?.title}</h2>
                        <p>{aboutUsData?.description}</p>
                    </div>
                    <div className={styles.aboutmainRight}>
                        <img src={aboutUsData?.image1} alt="login" />
                    </div>
                </div>
              
                {/*  Image gallery  */}
                <Border 
                title='Heritage Statement Pieces' 
                />

                <div className={styles.gallery}>
                    <div className={styles.col}>
                        <img src="/img/img2728.jpg" alt="JewelryImage" />
                    </div>
                    <div className={styles.col}>
                        <img src="/img/img2730.jpg" alt="JewelryImage" />
                    </div>
                    <div className={styles.col}>
                        <img src="/img/img2731.jpg" alt="JewelryImages" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Aboutus